import { FieldConfig } from '@common/financialEntities/config';
import React, { FC } from 'react';
import { Text, TextProps } from '../common/Typography';
import { FieldVal, formatValue } from './helpers';

export type ChangedField = {
    field: FieldConfig;
    oldVal: FieldVal;
    newVal: FieldVal;
};
export type ChangedFields = ChangedField[];

export interface ChangesDescriptionProps extends TextProps {
    changes: ChangedFields;
}

const ChangesDescription: FC<ChangesDescriptionProps> = ({
    changes,
    ...props
}) => {
    return (
        <Text {...props}>
            {'You changed '}
            {changes.map((change, ci) =>
                [
                    tokenFromChangedField(change),
                    getSeparatorToken(changes.length, ci),
                ].map((e, ei) => (
                    <React.Fragment key={change.field.name + ei}>
                        {e}
                    </React.Fragment>
                ))
            )}
        </Text>
    );
};

const tokenFromChangedField = ({
    field,
    oldVal,
    newVal,
}: ChangedField): JSX.Element => {
    const oldValStr = formatValue(oldVal, field);
    const newValStr = formatValue(newVal, field);

    return (
        <>
            ‘{field.label}‘ from <strong>{oldValStr}</strong> to{' '}
            <strong>{newValStr}</strong>
        </>
    );
};

const getSeparatorToken = (
    len: number,
    idx: number
): JSX.Element | undefined => {
    if (len < 2) return;

    if (len === 2) {
        if (idx === 0) {
            return <>{' and '}</>;
        }
        return;
    }

    // If we got here, length is 3 or more
    if (idx < len - 2) {
        return <>{', '}</>;
    }
    if (idx === len - 2) {
        return <>{', and '}</>;
    }
    return;
};

export default ChangesDescription;
